import { render, staticRenderFns } from "./Home.data-manager-bet365.vue?vue&type=template&id=79503e8e&scoped=true&"
import script from "./Home.data-manager-bet365.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-bet365.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-bet365.vue?vue&type=style&index=0&id=79503e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79503e8e",
  null
  
)

export default component.exports